import React from "react";
import { useClasses } from "../../";
import classNames from "classnames";
const styles = (theme) => ({
    main: {
        height: "calc(100vh - 115px)",
        overflowY: "scroll",
        padding: "32px 32px",
        [theme.breakpoints.down("sm")]: {
            height: "calc(100vh - 75px)",
            padding: "8px 8px 16px",
        },
        "@media print": {
            height: "auto",
            overflowY: "auto",
        },
    },
    container: {
        width: "100%",
        margin: "auto",
        "@media (min-width: 1930px)": {
            width: "1600px",
        },
    },
    page: {
        position: "relative",
    },
    overlayPage: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.palette.get("default"),
        "@media print": {
            position: "static",
        },
    },
    submenu: {
        "@media print": {
            display: "none",
        },
    },
});
export default function Admin(props) {
    var _a, _b, _c;
    const classes = useClasses(styles);
    return (React.createElement("div", { className: classNames([classes.page, (_a = props.override) === null || _a === void 0 ? void 0 : _a.page]) },
        React.createElement("div", { className: classes.submenu }, props.submenu),
        React.createElement("main", { className: classNames([classes.main, (_b = props.override) === null || _b === void 0 ? void 0 : _b.main]) },
            React.createElement("div", { className: classes.container }, props.children)), (_c = props.overlayPages) === null || _c === void 0 ? void 0 :
        _c.map((page, index) => (React.createElement("div", { key: "overlay-" + index, className: classes.overlayPage }, page)))));
}
